import { render, staticRenderFns } from "./ChannelCardSkeleton.vue?vue&type=template&id=40432c13&scoped=true"
import script from "./ChannelCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ChannelCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ChannelCardSkeleton.vue?vue&type=style&index=0&id=40432c13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40432c13",
  null
  
)

export default component.exports